<template>
  <!--Top-->
  <div class="m-k__row m-k__row_top" v-if="this.data.columns">
    <div class="m-k__c m-k__c_first">
      Наименование
    </div>
    <div v-for="column in this.data.columns.filter(c => !c.disable)"
         :class="['m-k__c', getColumnClasses(column)]"
    >
       {{ column.verboseMarketplace }} / {{ column.verboseSeller }}
    </div>
  </div>
</template>

<script>
import {markupsMixin} from "../../mixins/markupsMixin";
import {mapState} from "pinia";
import {useMarkupsStore} from "../../stores/markups";

export default {
  name: "TheTopLine",
  computed: {
    ...mapState(useMarkupsStore, [
      'data'
    ]),
  },
  mixins: [markupsMixin],
}
</script>